var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},_vm._l((_vm.items),function(item){return _c('a',{key:item,staticClass:"btn btn-xs btn-soft-secondary mb-1 mx-1",attrs:{"href":"javascript:;"}},[_vm._v(_vm._s(item))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }